import { FC, useState } from "react";
import { Modal } from "antd";
import { Avatar as AvatarAntd, Card, Button, Tooltip } from "antd";
import Avatar from "@/components/Avatar";
import CardUserProfile from "@/components/Card/card-user-profile";
import useWindowResize from "@/hooks/useWindowResize";
import { PAGE_URL } from "@/utils/constants";
import Link from "next/link";

const DEFAULT_MAX_DISPLAYED_AVATAR = 4;

type TProfileListCardProps = {
  users?: any;
  title?: string;
  maxDisplayedAvatar?: number;
  emptyMessage?: string;
  extraNode?: React.ReactNode;
};

export default function ProfileListCard({
  users = [],
  title,
  maxDisplayedAvatar = DEFAULT_MAX_DISPLAYED_AVATAR,
  emptyMessage = "",
  extraNode
}: TProfileListCardProps) {
  const [profileListModal, setProfileListModal] = useState<boolean>(false);
  const isMobile = useWindowResize();

  const renderViewMoreButton = (isViewMoreBtnDisplayed: boolean) =>
    isViewMoreBtnDisplayed && (
      <Button onClick={() => setProfileListModal(true)} type="text" style={{ padding: 0 }}>
        View More
      </Button>
    );

  return (
    <>
      <Card
        title={
          <div className="flex justify-between">
            <h3 className="font-bold text-lg text-white ">{title}</h3>
            {renderViewMoreButton(users?.length > maxDisplayedAvatar && !isMobile)}
          </div>
        }
      >
        {users?.length ? (
          <>
            <div>
              <AvatarAntd.Group>
                {users?.map(
                  (row: any, idx: number) =>
                    idx <= 3 && (
                      <Link href={`${PAGE_URL.profile}/${row?.id}`} key={`img-avatar-${idx}`}>
                        <Tooltip
                          trigger={isMobile ? "click" : "hover"}
                          title={`${row?.firstName} ${row?.lastName}`}
                          placement="top"
                          key={`img-avatar-${idx}`}
                        >
                          <Avatar
                            key={`champion-${idx}`}
                            src={row?.avatarUrl}
                            alt="avatar-user"
                            size="xxs"
                            name={row?.bio?.firstName}
                          />
                        </Tooltip>
                      </Link>
                    ),
                )}

                {users.length > maxDisplayedAvatar && (
                  <AvatarAntd style={{ backgroundColor: "#1677ff" }}>
                    +{users.length - maxDisplayedAvatar}
                  </AvatarAntd>
                )}
              </AvatarAntd.Group>
            </div>
            {renderViewMoreButton(users?.length > maxDisplayedAvatar && isMobile)}
          </>
        ) : (
          <>{emptyMessage}</>
        )}

        {extraNode}
      </Card>
      {profileListModal && (
        <ProfileListModal
          isOpen={profileListModal}
          handleClose={() => setProfileListModal(false)}
          users={users || []}
          title={title}
        />
      )}
    </>
  );
}

const ProfileListModal: FC<{
  isOpen: boolean;
  users: any[];
  handleClose: () => void;
  title?: string;
}> = ({ isOpen, handleClose, users = [], title = "" }) => {
  return (
    <Modal
      width={600}
      footer={null}
      open={isOpen}
      title={`${title} (${users.length})`}
      onCancel={handleClose}
    >
      {users?.length > 0 && (
        <div className="grid grid-cols-1 gap-4 py-5">
          {users?.map((item, index) => (
            <div
              key={index}
              className="flex justify-between items-center w-full"
              onClick={() => handleClose()}
            >
              <CardUserProfile
                avatarSize="sm"
                variant="horizontal"
                item={item}
                points={item?.points}
                findCG
              />
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
};
